export function base64toBlob(dataURI, mime) {
  const url = `data:${mime};base64,${dataURI}`;
  return fetch(url).then(res => res.blob());
}
